import { render, staticRenderFns } from "./add-general-imeis.vue?vue&type=template&id=52c436f0&scoped=true"
import script from "./add-general-imeis.vue?vue&type=script&lang=js"
export * from "./add-general-imeis.vue?vue&type=script&lang=js"
import style0 from "./add-general-imeis.vue?vue&type=style&index=0&id=52c436f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c436f0",
  null
  
)

export default component.exports